import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M.947 7.086 7.519.514m0 0H4.003m3.516 0V4.02" stroke="#007AFF" />
  </svg>
);
const Memo = memo(SvgArrowUpRight);
export default Memo;
